import { Identity } from '@ynap/api-utils';
import { SET_UBER_TOKEN, authActions } from '@ynap/auth-state';

export const updateUberToken = (dispatch, uberToken) => {
    dispatch({ type: SET_UBER_TOKEN, uberToken });
    authActions.dispatchUserChangeEvent(uberToken);
};

export const createFetchReplay = (fetch, request, options) => (uberToken) => {
    request.headers.set('X-Ubertoken', uberToken);

    return fetch(request, options);
};

export async function createGuestIdentity(fetch, config, uberToken) {
    const response = await fetch(Identity.createGuestIdentity({ ...config, uberToken }));
    if (!response.ok) {
        throw new Error(`Got status ${response.status} when trying to get a new guest identity`);
    }
    let json;
    try {
        json = await response.json();
    } catch (err) {
        throw new Error(`Encountered the following error when trying to get a new guest identity: ${err.message}\n${err.stack}`);
    }
    return json;
}

export const getWcsConfig = (state) => {
    const { config, locale, appState, uberToken } = state;
    const { country, language } = locale || appState;

    // legacy config support
    if (config.watsonService) {
        return { uberToken, country, language, ...config.watsonService };
    }

    const { global = { services: {}, application: {} } } = config;
    const commerce = global.services.commerce || config.wcs || {};
    const brandId = global.application.brandId || config.brandId;
    const baseUrl = commerce.baseUrl || (typeof window === 'undefined' ? commerce.internal?.baseUrl : commerce.external?.baseUrl);
    const clientId = commerce.clientId || (typeof window === 'undefined' ? commerce.internal?.clientId : commerce.external?.clientId);

    return { uberToken, country, language, brandId, baseUrl, clientId, ...commerce };
};

export const addCredentials = async (request, options) =>
    typeof request === 'string'
        ? [request, { credentials: 'same-origin', ...(options || {}) }]
        : [
              new Request(request.url, {
                  credentials: options?.credentials || 'same-origin',
                  method: request.method,
                  headers: request.headers,
                  body: ['GET', 'HEAD'].some((method) => request.method == method) ? null : await request.text(),
                  mode: request.mode,
                  cache: request.cache,
                  redirect: request.redirect,
                  referrer: request.referrer,
                  integrity: request.integrity,
              }),

              { credentials: 'same-origin', ...(options || {}) },
          ];
